import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import { Box, IconButton } from "@mui/material";
import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import useAPI from "../../../../api/hooks/useAPI";
import { ComplexEntityTypes, QueryParam } from "../../../../utils/constants";
import SmallEntityTypeCard from "../components/EntityTypeOverviewCard/SmallEntityTypeCard";

const SCROLL_JUMP = 250;

export default function SmallEntityTypeCards({ entitiesOverviewData }) {
  const scrollContainerRef = useRef(null);
  const { trackEvent } = useAPI();
  const [searchParams] = useSearchParams();

  const cards = Object.entries(entitiesOverviewData).filter(
    ([entityType, metadata]) =>
      Object.values(ComplexEntityTypes).includes(entityType) &&
      metadata.total_entities > 0
  );

  // Positions the cards so the selected one is visible
  const positionCards = () => {
    const scrollContainer = scrollContainerRef.current;
    let viewedCardIndex = 0;
    for (const [index, [entityType]] of cards.entries()) {
      if (entityType === searchParams.get(QueryParam.environmentType)) {
        viewedCardIndex = index + 1;
        break;
      }
    }
    if (
      scrollContainer.offsetWidth < scrollContainer.scrollWidth &&
      scrollContainer.offsetWidth < SCROLL_JUMP * viewedCardIndex
    ) {
      scrollContainer.scrollBy({
        left: SCROLL_JUMP * viewedCardIndex,
        behavior: "auto",
      });
    }
  };

  useEffect(() => {
    positionCards();
  }, []);

  const scrollRight = () => {
    trackEvent("Use scrolled right the small entity type cards");
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: SCROLL_JUMP,
        behavior: "smooth",
      });
    }
  };

  const scrollLeft = () => {
    trackEvent("Use scrolled left the small entity type cards");
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: -SCROLL_JUMP,
        behavior: "smooth",
      });
    }
  };

  return (
    <Box display="flex" flexDirection="row" alignItems="center" gap={0}>
      <Box>
        <IconButton
          onClick={scrollLeft}
          disabled={false}
          sx={{ padding: "0px" }}
        >
          <ArrowBackIosNewRoundedIcon
            sx={{
              width: "16px",
            }}
          />
        </IconButton>
      </Box>
      <Box
        display="flex"
        gap={3}
        ref={scrollContainerRef}
        sx={{
          padding: "3px 15px 3px 15px",
          overflowX: "auto",
          overflowY: "hidden",
          "&::-webkit-scrollbar": {
            display: "none",
          },
          msOverflowStyle: "none",
          scrollbarWidth: "none",
        }}
      >
        {cards.map(([entityType, metadata]) => (
          <SmallEntityTypeCard
            key={entityType}
            entityType={entityType}
            metadata={metadata}
          />
        ))}
      </Box>
      <Box>
        <IconButton
          onClick={scrollRight}
          disabled={false}
          sx={{ padding: "2px" }}
        >
          <ArrowForwardIosRoundedIcon
            sx={{
              width: "16px",
            }}
          />
        </IconButton>
      </Box>
    </Box>
  );
}
